
{
  document.addEventListener("DOMContentLoaded", function () {
    const allAccordions = document.querySelectorAll(".accordion_cus");
    allAccordions.forEach((accordion) => {
      const items = accordion.querySelectorAll(".acco_cus_item");
      if (items.length > 0) {
        items[0].classList.add("open");
      }
      items.forEach((item) => {
        const header = item.querySelector(".acc-header");
        header.addEventListener("click", () => {
          items.forEach((otherItem) => {
            if (otherItem !== item && otherItem.classList.contains("open")) {
              otherItem.classList.remove("open");
            }
          });
          item.classList.toggle("open");
        });
      });
    });
  });
}
{
  document.addEventListener("DOMContentLoaded", function () {
  gsap.registerPlugin(ScrollTrigger);
  gsap.utils.toArray(".anim-Y-img").forEach((element) => {
    const isMobile = window.innerWidth <= 767;
    gsap.fromTo(
      element,
      { scale: 1.2 },
      {
        scale: 1,
        ease: "none",
        scrollTrigger: {
          trigger: element,
          start: "top 90%",
          end: isMobile ? "top 50%" : "top 30%",
          scrub: 1,
        },
      }
    );
  });
});

}


// Singgle product Faq Script Start
 {
    document.addEventListener("DOMContentLoaded", function () {
      const items = document.querySelectorAll(".product_acco_cus_item");
      items.forEach((item) => {
        item.addEventListener("click", () => {
          if (item.classList.contains("open")) {
            item.classList.remove("open");
          } else {
            items.forEach((el) => el.classList.remove("open"));
            item.classList.add("open");
          }
        });
      });
    });
  }
// Singgle product Faq Script End


{
  document.addEventListener("DOMContentLoaded", () => {
    let lastScrollTop = 0;
    const navbar = document.querySelector(".Main_Header_top");
    /* LUCA BIONDI - FIXED CONSOLE ERROR */
    if (!navbar) return;
    /* LUCA BIONDI - FIXED CONSOLE ERROR END HERE */

    window.addEventListener("scroll", () => {
      const currentScroll = window.scrollY;
      currentScroll >= 200
        ? navbar.classList.add("sticky_nav")
        : currentScroll === 0 && navbar.classList.remove("sticky_nav"),
        currentScroll > 300 && currentScroll > lastScrollTop
          ? navbar.classList.add("navbar-hide")
          : currentScroll < lastScrollTop &&
            navbar.classList.remove("navbar-hide"),
        (lastScrollTop = currentScroll <= 0 ? 0 : currentScroll);
    }),
      window.innerWidth > 1024 &&
        (document.body.addEventListener("mouseleave", () => {
          window.scrollY > 0 && navbar.classList.add("navbar-hide");
        }),
        document.body.addEventListener("mouseenter", () => {
          window.scrollY > 0 && navbar.classList.remove("navbar-hide");
        }));
  });
}

{
document.addEventListener("DOMContentLoaded", function () {
  if (window.innerWidth > 768) return;
  const sections = document.querySelectorAll(".Btns_Bottom_sticky");
  function checkPositions() {
    sections.forEach((section) => {
      const btn = section.querySelector(".main_Btn");
      if (!btn) return;
      const rect = section.getBoundingClientRect();
      if (rect.bottom < 0) {
        btn.classList.add("sticky-btn");
      } else if (rect.top < window.innerHeight && rect.bottom > 0) {
        btn.classList.remove("sticky-btn");
      }
    });
  }
  window.addEventListener("scroll", checkPositions);
});
}
{
  document.addEventListener("DOMContentLoaded", function () {
    AOS.init();
  });
}